import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import Home from "@/pages/Home";
import AboutUs from "@/pages/AboutUs";
import Services from "@/pages/Services";
import Products from "@/pages/Products";
import Industries from "@/pages/Industries";
import GlobalPresence from "@/pages/GlobalPresence";
import Contact from "@/pages/Contact";
import RequestQuote from "@/pages/RequestQuote";
import CompanyUAE from "@/pages/CompanyUAE";
import CompanyDubai from "@/pages/CompanyDubai";
import CompanyUK from "@/pages/CompanyUK";
import CompanyUSA from "@/pages/CompanyUSA";

function App() {
  // Remove Emergent branding elements (but not user content)
  useEffect(() => {
    const removeEmergentBranding = () => {
      // ONLY remove specific branding elements, NOT user content
      document.querySelectorAll("a, span, div, button").forEach(el => {
        const className = el.className?.toLowerCase() || '';
        const id = el.id?.toLowerCase() || '';
        const href = el.href?.toLowerCase() || '';
        
        // Only hide if it's an actual Emergent branding element
        // NOT if it's just text content mentioning Emergent (like "Powered by Emergent")
        const isEmergentBranding = (
          className.includes("emergent-badge") ||
          className.includes("emergent-watermark") ||
          id.includes("emergent-badge") ||
          id.includes("emergent-watermark") ||
          (href.includes("emergentagent.com") && el.textContent?.toLowerCase().includes("made with"))
        );
        
        if (isEmergentBranding) {
          el.style.display = "none";
          el.style.visibility = "hidden";
          el.style.opacity = "0";
          el.style.pointerEvents = "none";
        }
      });
    };

    // Run immediately
    removeEmergentBranding();

    // Run after a delay to catch dynamically added elements
    const timer = setTimeout(removeEmergentBranding, 1000);

    // Set up a mutation observer to catch any dynamically added branding
    const observer = new MutationObserver(removeEmergentBranding);
    observer.observe(document.body, { 
      childList: true, 
      subtree: true 
    });

    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/services" element={<Services />} />
          <Route path="/products" element={<Products />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/global-presence" element={<GlobalPresence />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/quote" element={<RequestQuote />} />
          <Route path="/company/uae-trading" element={<CompanyUAE />} />
          <Route path="/company/dubai-marketing" element={<CompanyDubai />} />
          <Route path="/company/uk" element={<CompanyUK />} />
          <Route path="/company/usa" element={<CompanyUSA />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
